const useAcceptedDocuments = (user) => {
    const activeTosVersionAccepted = user?.acceptedDocuments?.some(
        (doc) => doc.version === process.env.REACT_APP_TOS_ACTIVE_VERSION
    );
    const activeDpaVersionAccepted = user?.acceptedDocuments?.some(
        (doc) => doc.version === process.env.REACT_APP_DPA_ACTIVE_VERSION
    );

    return { activeTosVersionAccepted, activeDpaVersionAccepted };
};

export default useAcceptedDocuments;
